<div (click)="globalVars.isLeftBarMobileOpen = true;">
    <i class="fas fa-bars fa-lg fc-secondary"></i>
</div>